import React, { useEffect } from 'react';
import DesktopView from '../components/views/DesktopView';
import MobileView from '../components/views/MobileView';
import Footer from '../features/navigation/Footer';

interface MainPageProps {
  isMobile: boolean;
  currentSection: number;
  sections: Array<{
    id: string;
    Component: React.ComponentType<{ isActive?: boolean }>;
  }>;
}

// * [PAGE] Main landing portfolio containing core sections and global footer
export const MainPage: React.FC<MainPageProps> = ({
  isMobile,
  currentSection,
  sections,
}) => {
  useEffect(() => {
    document.title = 'Yash Haldiya | AI Engineer & Developer';
  }, []);

  return (
    <div className="main-portfolio-page">
      {isMobile ? (
        <MobileView currentSection={currentSection} sections={sections} />
      ) : (
        <DesktopView currentSection={currentSection} sections={sections} />
      )}
      <Footer />
    </div>
  );
};

export default MainPage;
